export default __webpack_public_path__ + "svg/CompaniesLogos/logo_wam.svg?68f0a9d8";